export const USAGE_PERCENTAGE_LIMIT_THRESHOLD = 75;

// Marketing's verbatim URL. Stripping the HubSpot email tracking parameters, or swapping them for
// in-app UTMs, was proposed and rejected (PRE-3487, 2026-09-04); the accepted consequence is that
// in-app clicks are attributed to the email campaign. Do not "clean" them up.
export const PRICING_UPDATE_2026_ARTICLE_URL =
  'https://docs.prerender.io/docs/pricing-update-2026?utm_campaign=483022072-PRISM&utm_medium=email&_hsenc=p2ANqtz-_5Zm3vFaduii3yjfUmkK4N2dH82uP0unxBgD66muUtnR2RdYfRf_Er2vGtvpTRr1qbjg0hHJ_lom3cQoN5VHgbxRdydg&_hsmi=144647778&utm_content=144647778&utm_source=hs_email';
